/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * BankAccounts. List of bank accounts.
 */
export interface BankAccountParam { 
    /**
     * IBAN of the bank account. Maximum lenght 24
     */
    iban: string;
    /**
     * SWIFT of the bank account. Maximum lenght 11
     */
    swift: string;
    /**
     * List of Holders of the bank account with slash separator. Maximum lenght 255
     */
    holders: string;
    /**
     * Address of the bank account. Maximum lenght 255
     */
    accountAddress: string;
    /**
     * Currency type of the bank account. Format ISO 4217, Example: Euro = EUR. Maximum lenght 3
     */
    currencyType: string;
    /**
     * Name of the bank account. Maximum lenght 100
     */
    bankName: string;
    /**
     * User Id Hash. UUI (Unique User Identifier)
     */
    userIdHash: string;
}

